module.exports = __webpack_public_path__ + "static/omnichannel@2x-ecd7be796aaed10a6a837d542e86e89f.png";